import { ChangeEvent, FC, useEffect, useState } from 'react';
import { observable, IObservableValue } from 'mobx';
import { useStyles } from './styles';
import { Button, Checkbox, FormControlLabel, Grid, IconButton, Paper, Tab, Tabs } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import TabPanel from 'components/TabPanel';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PeopleIcon from '@material-ui/icons/People';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useStore } from 'hooks/useRootStore';
import { UpgradeLicenseFormInput, UpgradeLicenseFormProps } from 'components/Forms';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { CoreFeatures } from 'components/PopUps/SubscriptionPopup/CoreFeatures';
import { PremiumSupport } from 'components/PopUps/SubscriptionPopup/PremiumSupport';
import LicenseForm from '../LicenseForm';
import LicensePreview from '../PreviewScreen/LicensePreview';
import { Controller, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { toFormatDate, toFormatSum } from 'utils';
export const UpgradeLicenseForm: FC<UpgradeLicenseFormProps> = observer(({ alowPlanSelection }) => {
  const classes = useStyles();
  const history = useHistory();
  useEffect(() => {
    document.title = 'EasyIdentity: Upgrade License';
  }, []);
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const [values, setValues] = useState<string>('one');
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValues(newValue);
  };
  const {
    upgradeLicenseStore: { getUpgradeLicenseInfo, upgradeLicense, upgradelicenseplan, previousLicense, lisenceInfo },
    notificationStore: { openNotification, setUpgradeNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  const getUpgradeLicense = useQuery('getUpgradeLicense', () => getUpgradeLicenseInfo(), {
    onError: () => openNotification('error', `Can't get upgrade license info`),
  });

  const upgradeLicenseReq = useMutation((data: []) => upgradeLicense(data), {
    mutationKey: 'upgradeLicenseReq',
    onSuccess: () => {
      disablePreloader();
      setValues('three');
    },
    onError: (error: Error) => openNotification('error', error.message),
  });
  const { handleSubmit, control } = useForm<UpgradeLicenseFormInput>();
  const [selected, setSelected] = useState<string>('monthly');
  const [addonPer, setAddonPer] = useState<string>('');
  const [corePer, setCorePer] = useState<string>('');
  const [users, setUsers] = useState<number>(1);
  const [userAddon, setUserAddon] = useState<number>(1);
  const [checkedu, setCheckEdu] = useState<string>('');
  const [discountCore, setDiscountCore] = useState<string>('');
  const [discountAddon, setDiscountAddon] = useState<string>('');
  const [paymentData, setPaymentData] = useState<string>('');
  const [data, setData] = useState<any | null>([]);
  const [addonCheckBox, setAddonCheckbox] = useState<boolean>(false);
  const [coreCheckBox, setCoreCheckBox] = useState<boolean>(true);

  const expiryChecker = (expire: any) => {
    const firstDate = new Date();

    const observableDate: IObservableValue<Date | null> = observable.box<Date | null>(null);
    observableDate.set(new Date(previousLicense?.currentDate as string));
    const seconDate = new Date(expire);
    const finalDate = Math.abs(+seconDate - +firstDate);
    const format = Math.ceil(finalDate / (1000 * 3600 * 24));
    return format;
  };

  const days = () => {
    if (coreCheckBox === true && addonCheckBox === true) {
      const expireCore: any = previousLicense?.dateUsersCoreExpire
        ? new Date(previousLicense.dateUsersCoreExpire)
        : null;
      if (previousLicense?.dateUsersAddonExpire === null) {
        if (expireCore) {
          return expiryChecker(expireCore);
        }
      } else if (coreCheckBox === true && addonCheckBox === true && corePer === 'monthly' && addonPer === 'yearly') {
        if (expireCore) {
          return expiryChecker(expireCore);
        }
        const expireAddon: any = previousLicense?.dateUsersAddonExpire
          ? new Date(previousLicense.dateUsersAddonExpire)
          : null;
        if (expireAddon) {
          return expiryChecker(expireAddon);
        }
      } else if (coreCheckBox === true && addonCheckBox === true && corePer === 'yearly' && addonPer === 'yearly') {
        if (expireCore) {
          return expiryChecker(expireCore);
        }
        const expireAddon: any = previousLicense?.dateUsersAddonExpire
          ? new Date(previousLicense.dateUsersAddonExpire)
          : null;
        if (expireAddon) {
          return expiryChecker(expireAddon);
        }
      } else {
        const expireAddon: any = previousLicense?.dateUsersAddonExpire
          ? new Date(previousLicense.dateUsersAddonExpire)
          : null;
        if (expireCore && expireAddon) {
          const maxExpire = new Date(Math.max(expireCore.getTime(), expireAddon.getTime()));
          return expiryChecker(maxExpire);
        }
      }
    } else if (coreCheckBox === true) {
      const expireCore: any = previousLicense?.dateUsersCoreExpire
        ? new Date(previousLicense.dateUsersCoreExpire)
        : null;
      if (expireCore) {
        return expiryChecker(expireCore);
      }
    } else if (addonCheckBox === true) {
      const expireAddon: any = previousLicense?.dateUsersCoreExpire
        ? new Date(previousLicense.dateUsersCoreExpire)
        : null;
      if (expireAddon) {
        return expiryChecker(expireAddon);
      }
    }
    return 0;
  };

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const firstDayOfYear = new Date(currentYear, 0, 1);
  const lastDayOfYear = new Date(currentYear, 11, 31);
  const differenceInDays = Math.ceil((Number(lastDayOfYear) - Number(firstDayOfYear)) / (1000 * 60 * 60 * 24)) + 1;

  const addonPrice = () => {
    if (addonCheckBox === true) {
      const getprice: number | any = upgradelicenseplan.map((price: any) =>
        price.name === 'Add-On' && selected === 'monthly' && checkedu === 'yes'
          ? +price.edu_paid_monthly
          : price.name === 'Add-On' && selected === 'monthly' && checkedu === 'no'
          ? +price.price_paid_monthly
          : price.name === 'Add-On' && selected === 'yearly' && checkedu === 'no'
          ? +price.price_paid_yearly
          : price.name === 'Add-On' && selected === 'yearly' && checkedu === 'yes'
          ? +price.edu_paid_yearly
          : ''
      );
      const newprice = getprice?.filter((pric: any) => pric !== '');
      return addonPriceConditions(newprice);
    }
    return 0;
  };
  const corePrice = () => {
    const getprice: number | any = upgradelicenseplan.map((price: any) =>
      price.name === 'Core' && corePer === 'monthly' && checkedu === 'yes'
        ? +price.edu_paid_monthly
        : price.name === 'Core' && corePer === 'monthly' && checkedu === 'no'
        ? +price.price_paid_monthly
        : price.name === 'Core' && corePer === 'yearly' && checkedu === 'no'
        ? +price.price_paid_yearly
        : price.name === 'Core' && corePer === 'yearly' && checkedu === 'yes'
        ? +price.edu_paid_yearly
        : ''
    );
    const newprice = getprice?.filter((pric: any) => pric !== '');
    return corePriceCondtions(newprice);
  };
  const addonPriceConditions = (newprice: number) => {
    if (previousLicense?.addon === 'yes' && previousLicense?.numberOfUsersAddOn > 0) {
      if (previousLicense.paymentPeriodUsersAddon === 'yearly' && addonPer === 'yearly') {
        const peruserCose = newprice / differenceInDays;
        const newPerUserCost = peruserCose;
        const finalprice = +newPerUserCost * days() * users;
        const y = finalprice.toFixed(2);
        return +y;
      }
      const finalprice = newprice * users;
      const y = finalprice.toFixed(2);
      return +y;
    }
    const finalprice = newprice * userAddon;
    const y = finalprice.toFixed(2);
    return +y;
  };
  const corePriceCondtions = (newprice: number) => {
    if (previousLicense?.core === 'yes') {
      if (previousLicense.paymentPeriodUsersCore === 'yearly' && corePer === 'yearly') {
        const peruserCose = newprice / differenceInDays;
        const newPerUserCost = peruserCose;
        const finalprice = +newPerUserCost * days() * users;
        const y = finalprice.toFixed(2);
        return +y;
      } else if (previousLicense.paymentPeriodUsersCore === 'monthly' && corePer === 'monthly') {
        const userCost = newprice / 30;
        const newPerUserCost = userCost;
        const finalprice = +newPerUserCost * days() * users;
        const y = finalprice.toFixed(2);
        return +y;
      }
      const finalprice = newprice * users;
      const y = finalprice.toFixed(2);
      return +y;
    }
    const finalprice = newprice * users;
    const y = finalprice.toFixed(2);
    return +y;
  };

  const valueChecker = (fnf: number) => {
    if (fnf > 999999) {
      setUpgradeNotification(true);
      openNotification(
        'error',
        'The amount in not support by the payment processor, Please decrease the number of users to upgrade your plan.'
      );
    }
  };
  const finalAmount = () => {
    if (coreCheckBox === true && addonCheckBox === true) {
      const fnf = +calculatePrice() + +calculatePrices();
      return fnf.toFixed(2);
    } else if (addonCheckBox === true) {
      const fnf = +calculatePrices();
      return fnf.toFixed(2);
    }
    const fnf = +calculatePrice();
    valueChecker(fnf);
    return fnf.toFixed(2);
  };

  const formdata = (data: UpgradeLicenseFormInput) => {
    const arr: {
      paymentperCore?: string;
      type: string;
      numberOfUserAccountsCore?: number;
      discountCodeCore?: string;
      coreFeature?: string;
      organization: string;
      paymentMethod: string;
      paymentperAddOn?: string;
      numberOfUserAccountsAddOn?: number;
      discountCodeAddOn?: string;
      addOnservice?: string;
    }[] = [];
    if (values === 'one') {
      const core = {
        coreFeature: data.coreFeature,
        paymentperCore: (data.paymentperCore = corePer),
        type: 'core',
        numberOfUserAccountsCore: users,
        discountCodeCore: discountCore,
        organization: checkedu,
        paymentMethod: paymentData,
      };
      arr.push(core);
      const numberOfUserAccountsAddOn = previousLicense?.addon === 'yes' ? users : userAddon;
      const addon = {
        addOnservice: data.addOnservice,
        paymentperAddOn: (data.paymentperAddOn = addonPer),
        type: 'addon',
        numberOfUserAccountsAddOn: numberOfUserAccountsAddOn,
        discountCodeAddOn: discountAddon,
        organization: checkedu,
        paymentMethod: paymentData,
      };
      arr.push(addon);
      setData((value: any) => [...value, arr]);
    } else {
      const addon = {
        addOnservice: data.addOnservice,
        paymentperAddOn: (data.paymentperAddOn = addonPer),
        type: 'addon',
        numberOfUserAccountsAddOn: userAddon,
        discountCodeAddOn: discountAddon,
        organization: checkedu,
        paymentMethod: paymentData,
      };
      arr.push(addon);
      setData((value: any) => [...value, arr]);
    }
  };

  const onSubmit = () => {
    if (formdata.length >= 1) {
      const flatData = data.flat();
      const unique: any = Object.values(
        flatData.reduce((a: any, item: any) => {
          a[item.type] = item;
          return a;
        }, {})
      );
      if (addonCheckBox === false) {
        const checkData = unique.filter((val: any) => val.type !== 'addon');
        upgradeLicenseReq.mutate(checkData);
      } else if (coreCheckBox === false) {
        const checkData = unique.filter((val: any) => val.type !== 'core');
        upgradeLicenseReq.mutate(checkData);
      } else {
        upgradeLicenseReq.mutate(unique);
      }
    }
  };
  const dateCalc = () => {
    const currdate = new Date();
    const durations = lisenceInfo?.aclPaymentDueDate;
    if (durations === '' || durations === undefined) {
      if (corePer === 'monthly' && values === 'one') {
        const finalDate = new Date(currdate.setDate(currdate.getDate() + 30));
        return finalDate.toISOString().split('T')[0];
      } else {
        const finalDate = new Date(currdate.setDate(currdate.getDate() + 365));
        return finalDate.toISOString().split('T')[0];
      }
    } else {
      return durations;
    }
  };
  function calculatePrice() {
    if (corePer === 'monthly' && values === 'one') {
      const price = corePrice();
      return price.toFixed(2);
    } else {
      const price = corePrice();
      return price.toFixed(2);
    }
  }
  calculatePrice();

  // addonPrice
  function calculatePrices() {
    const price = addonPrice();
    return price.toFixed(2);
  }
  calculatePrices();
  useAppPreloader(getUpgradeLicense.isLoading);
  return (
    <Grid className={classes.main}>
      <Paper className={classes.paper} elevation={3}>
        <Grid className={classes.topBar} container justify='space-between' alignItems='center'>
          <div className={classes.title}>Upgrade License</div>
          <IconButton
            style={{ marginRight: -16 }}
            onClick={() => {
              history.goBack();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid container justify='space-between'>
          <Grid item xl className={classes.tabsPanel}>
            <Paper className={classes.tabsPaper}>
              <div className={classes.license}>
                <div className={classes.bartitle}>Current license:</div>
                <div className={classes.tabdetail}>
                  <div className={classes.tabdetailIcon}>
                    <AccessTimeIcon className={classes.icons} />
                    <span>
                      {corePer === 'monthly' && values === 'one'
                        ? 'One Month Subscription'
                        : corePer === 'yearly' && values === 'one'
                        ? 'One Year Subscription'
                        : addonPer === 'yearly' && values === 'two'
                        ? 'One Year Subscription'
                        : 'One Month Subscription'}
                    </span>
                  </div>
                  <div className={classes.tabdetailIcon}>
                    <PeopleIcon className={classes.icons} />
                    <span>
                      Number of users:&nbsp;
                      {values === 'one'
                        ? `${toFormatSum(users)}`
                        : `${toFormatSum(users)}` !== ' '
                        ? `${toFormatSum(users)}`
                        : '1'}
                    </span>
                  </div>
                  <div className={classes.tabdetailIcon}>
                    <DateRangeIcon className={classes.icons} /> <span>Expires: {toFormatDate(dateCalc())} </span>
                  </div>
                </div>
              </div>
              <Tabs
                value={values}
                className={classes.tabs}
                TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
                onChange={handleChange}
              >
                <Tab
                  value='one'
                  onClick={handleSubmit(formdata)}
                  wrapped
                  disabled={values === 'three'}
                  label='Core Features'
                  {...a11yProps('one')}
                  className={classes.tablabel}
                />
                <Tab
                  value='two'
                  wrapped
                  disabled={values === 'three'}
                  label='Add-On Services'
                  {...a11yProps('two')}
                  onClickCapture={handleSubmit(formdata)}
                  onClick={(e: any) => {
                    setSelected('yearly');
                  }}
                  className={classes.tablabel}
                ></Tab>
                <Tab
                  value='three'
                  wrapped
                  label='Preview'
                  disabled
                  {...a11yProps('three')}
                  className={classes.tablabel}
                />
              </Tabs>
              <div className={classes.tabBox}>
                <div className={classes.row}>
                  <TabPanel value={values} index='one'>
                    <div className={classes.addfeatures}>
                      <Controller
                        name='coreFeature'
                        defaultValue='1'
                        control={control}
                        render={({ field, fieldState: { invalid, error } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={field.value !== '' && field.value !== '0'}
                                onChange={(event: any, checked: boolean) => {
                                  field.onChange(`${+checked}`);
                                  setCoreCheckBox(event.target.checked);
                                }}
                                required
                                name='core'
                                className={classes.addfeatureCheckbox}
                                color='primary'
                              />
                            }
                            label={'Core Features  '}
                          />
                        )}
                      />
                    </div>
                    <div className={classes.coreFeatures}>
                      <CoreFeatures />
                    </div>
                  </TabPanel>
                  <TabPanel value={values} index='two'>
                    <div className={classes.addfeatures}>
                      <Controller
                        name='addOnservice'
                        defaultValue='0'
                        control={control}
                        render={({ field, fieldState: { invalid, error } }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={field.value !== '' && field.value !== '0'}
                                onChange={(event: any, checked: boolean) => {
                                  field.onChange(`${+checked}`);
                                  setAddonCheckbox(event.target.checked);
                                }}
                                required
                                name='addOn'
                                className={classes.addfeatureCheckbox}
                                color='primary'
                              />
                            }
                            label={'Add-On Services  '}
                          />
                        )}
                      />
                    </div>
                    <div className={classes.coreFeatures}>
                      <PremiumSupport />
                    </div>
                  </TabPanel>
                  <LicenseForm
                    indexValue={values}
                    selectedValue={selected}
                    user={setUsers}
                    addonPeriod={setAddonPer}
                    corePeriod={setCorePer}
                    edu={setCheckEdu}
                    discountAddon={setDiscountAddon}
                    discountCore={setDiscountCore}
                    payment={setPaymentData}
                    userAddon={setUserAddon}
                  />
                  <TabPanel value={values} index='three'>
                    <LicensePreview
                      paymentMethod={paymentData}
                      totalUsers={users}
                      addonCheckBox={addonCheckBox}
                      coreCheckBox={coreCheckBox}
                      totalPrice={toFormatSum(finalAmount())}
                      corePrice={coreCheckBox ? toFormatSum(calculatePrice()) : '0'}
                      addonPrice={addonCheckBox ? toFormatSum(calculatePrices()) : '0'}
                      finalAmount={toFormatSum(finalAmount())}
                      userAddon={userAddon}
                    />
                  </TabPanel>
                </div>

                {values === 'three' ? (
                  ''
                ) : (
                  <Grid container className={classes.topBar}>
                    <Grid container item xs={6} className={classes.priceBar}>
                      <div className={classes.subPrice}>
                        {coreCheckBox === true ? (
                          <>
                            <p className={classes.priceBox}>Core Features:</p>{' '}
                            <span>${toFormatSum(calculatePrice())} USD</span>
                          </>
                        ) : (
                          <>
                            <p className={classes.priceBox}></p>
                          </>
                        )}
                      </div>
                      <div className={classes.subPrice}>
                        {addonCheckBox === true ? (
                          <>
                            <p className={classes.priceBox}>Add-On Services:</p>{' '}
                            <span>${toFormatSum(calculatePrices())} USD</span>
                          </>
                        ) : (
                          <>
                            <p className={classes.priceBox}></p>
                          </>
                        )}
                      </div>
                      <div className={classes.price}>
                        {coreCheckBox === false && addonCheckBox === false ? (
                          <>
                            <p className={classes.priceBox}>Total Price:</p> <span>$0.00 USD</span>
                          </>
                        ) : (
                          <>
                            <p className={classes.priceBox}>Total Price:</p>{' '}
                            <span>${toFormatSum(finalAmount())} USD</span>
                          </>
                        )}
                      </div>
                    </Grid>
                    <Grid container item xs={6} style={{ display: 'flex', alignItems: 'center' }} justify='center'>
                      <div className={classes.stripe}>
                        Powered by<span>&nbsp;stripe</span>
                      </div>
                    </Grid>
                  </Grid>
                )}

                <Grid
                  container
                  className={values === 'one' || values === 'two' ? `${classes.blockbtn}` : `${classes.blockbtn1}`}
                  justify='space-between'
                  alignItems='center'
                >
                  <Grid className={classes.block} container>
                    <Grid container item xs={6}>
                      {values === 'three' ? (
                        <Button
                          className={classes.btn1}
                          onClick={() => {
                            setValues('one');
                          }}
                          fullWidth
                          variant='contained'
                          color='primary'
                        >
                          Back
                        </Button>
                      ) : values === 'one' ? (
                        <Button
                          className={classes.btn1}
                          onClick={() => {
                            history.goBack();
                          }}
                          fullWidth
                          variant='contained'
                          color='primary'
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Button
                          className={classes.btn1}
                          onClick={() => {
                            setValues('one');
                          }}
                          fullWidth
                          variant='contained'
                          color='primary'
                        >
                          Back
                        </Button>
                      )}
                    </Grid>
                    <Grid container item xs={6} justify='center'>
                      {values === 'three' ? (
                        <Button
                          className={classes.btn2}
                          onClick={() => {
                            history.goBack();
                          }}
                          fullWidth
                          variant='contained'
                          color='secondary'
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Button
                          className={classes.btn2}
                          onClickCapture={handleSubmit(formdata)}
                          onClick={() => {
                            onSubmit();
                            setValues('three');
                          }}
                          disabled={
                            (previousLicense?.addon === 'yes' &&
                              previousLicense?.core === 'yes' &&
                              !(addonCheckBox && coreCheckBox)) ||
                            ((previousLicense?.addon === 'no' || previousLicense?.core === 'no') &&
                              !(addonCheckBox || coreCheckBox)) ||
                            +finalAmount() > 999999
                          }
                          fullWidth
                          variant='contained'
                          color='secondary'
                        >
                          Next
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
});
